<form [formGroup]="liabilitiesForm" id="liabilities-form" (ngSubmit)=onSubmit(liabilitiesForm)>
	<div class="d-flex flex-column justify-content-center text-center flex-column m-step-wrapper1 container" [ngClass]="{'first-question' : !prevQID}">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion" (editQuestionChange)="editQuestionChange($event)">

			<question [qID]="'1'">
				<h3>{{"LIABILITIES.QUESTION1.QUESTION"|translate}}</h3>
				<inner-tooltip [qTitle]="'LIABILITIES.QUESTION1.TOOLTIP_TITLE'|translate" 
					[text]="'LIABILITIES.QUESTION1.TOOLTIP_TEXT'|translate"
					class="m-inner-popover">
				</inner-tooltip>
				<div class="btn-group-toggle" data-toggle="buttons">
					<label class="btn btn-primary" [ngClass]="{'selected':liabilitiesForm.get('haveYouLiabilities').value==='YES'}">
						{{"COMMON.YES"|translate}}
						<input type="radio" formControlName="haveYouLiabilities" value="YES" (change)="onSubmit(liabilitiesForm)" click2change>
					</label>
					<label class="btn btn-primary" [ngClass]="{'selected':liabilitiesForm.get('haveYouLiabilities').value==='NO'}">
						{{"COMMON.NO"|translate}}
						<input type="radio" formControlName="haveYouLiabilities" value="NO" (change)="onSubmit(liabilitiesForm)" click2change>
					</label>
				</div>
			</question>
			
			<question [qID]="'2'">
				<h3>{{"LIABILITIES.QUESTION2.QUESTION"|translate}}</h3>
				<app-liabilities-array formArrayName="liabilitiesArray" 
						[liabilitiesArray]="liabilitiesForm.get('liabilitiesArray')" 
						[displayErrors]="submitted"
						[qID]= "'2'"
				 		(onAddFormGroup)="setValidators()">
				</app-liabilities-array>
				<br/>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary" 
					[ngClass]="{'m-valid' : liabilitiesForm.valid && qID=='2'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>

		</questions-manager>
	</div>
</form>


// WEBPACK FOOTER //
// ./src/app/liabilities/liabilities.component.html